import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Image } from '../../Image/Image.js';
import styles from './icon-marker.module.css.js';

function IconMarker({
  lat: _lat,
  lng: _lng,
  hoverSrc,
  alt = '',
  children,
  onClick,
  className,
  src
}) {
  return jsx("div", {
    className: clsx('group absolute -top-2xl z-20 -translate-x-2/4 object-contain hover:z-30 hover:cursor-pointer', styles.iconMarkerContainer, className),
    onClick: onClick,
    children: jsxs("div", {
      className: "relative",
      children: [jsx(Image, {
        src: src,
        className: clsx({
          'group-hover:hidden': !!hoverSrc
        }),
        alt: alt
      }), !!hoverSrc && jsx(Image, {
        src: hoverSrc,
        className: "hidden group-hover:block",
        alt: alt
      }), children]
    })
  });
}

export { IconMarker };
